import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  ProjectJobServiceCreateResponseJson,
  ProjectJobServiceListRequestJson,
} from '@vmspdb/definitions';
import { ApiPaginated } from '@vmspdb/ui/domain';

export const PaginatedProjectJobActions = createActionGroup({
  source: 'PaginatedProjectJob',
  events: {
    Nothing: emptyProps(),
    Cancel: emptyProps(),
    'List PaginatedProjectJobs': props<{
      params: ProjectJobServiceListRequestJson;
    }>(),
    'List PaginatedProjectJobs Success': props<{
      data: ApiPaginated<ProjectJobServiceCreateResponseJson>;
    }>(),
    'List PaginatedProjectJobs Failure': props<{ error: unknown }>(),
  },
});
